const Regex = {
    pancard: "[A-Z]{3}[P]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}",
    license: "^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$",
    aadhar: "^[1-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$",
    passport: "^[A-PR-WYa-pr-wy][1-9]\\d\\s?\\d{4}[1-9]$",
    ifscCode: "^[A-Z]{4}0[A-Z0-9]{6}$",
    // onlyAlphabhets: "^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$",
    onlyAlphabhets: "^[A-Za-z ]+$",
    onlyNumeric: "^[0-9]*$",
    alphabhetSpace: "^[a-zA-Z ]*$",
    alphanumSpace: "^[a-zA-Z0-9 ]*$",
    alphanumeric: "^[a-zA-Z0-9]*$",
    alphabhetSpaceSpl: "^[ A-Za-z0-9\\-.'&/]*$",
    accountNumber: "^[0-9]{9,18}$",
    mob: "^[6-9]+[0-9]{9}$",
    email: "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$"
    // phoneRegExp: "/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/"
  }
  
  export default Regex